import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import AppUpdateContent from './AppUpdateContent';
import AppUpdateGeneral from './AppUpdateGeneral';
import { SaveAndBackButtons } from '../../components/base/BottomStepComponent';
import ContentSections from '../../components/base/ContentSections';
import { APIStatus } from 'config/CustomEnums';
import Loading from 'components/base/Loading';
import './AppUpdateStepOne.scss';


const AppUpdateStepOne = ({
  loadingStatus,
  languages,
  setShowCompleteProcess,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { getValues } = useFormContext();

  useEffect(() => {
    dispatch({
      type: 'language/getList',
      payload: {
        isSelectorLoad: true,
      }
    });
  }, [dispatch]);

  const getLanguageTab = (language) => {
    return [<AppUpdateContent language={language} />];
  };

  const languageTabConfig = {
    containers: languages?.map((item) => ({
      container: getLanguageTab(item.code),
      key: item.code,
      title: item.sourceName,
    })),
  };

  const save = () => {
    console.log('@@75', getValues());
    dispatch({
      type: 'appUpdate/updateAppUpdate',
      payload: {
        values: getValues(),
        afterActions: () => {
          setShowCompleteProcess(true);
        },
      }
    });
  };

  if (loadingStatus === APIStatus.calling) {
    return <Loading />
  };

  return (
    <>
      <ContentSections
        contentStyle="app-update-step-one-general-section"
        sections={[<AppUpdateGeneral />]}
        hidePreview={true}
      />

      <ContentSections
        languageTabContent={languageTabConfig}
        hidePreview
      />

      <SaveAndBackButtons
        backAction={() => {
          history.goBack();
        }}
        saveText={'Save'}
        saveAction={save}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  loadingStatus: state.appUpdate.loadingStatus,
  languages: state.language.allList,
})

export default connect(mapPropsToState)(AppUpdateStepOne);
